import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IConditionnement } from '../models/conditionnements.model';
import { Conditionnement } from '../../features/parameters/referentials/referentials-conditionnements/conditionnement.model';
import { environment } from '../../../environments/environment';
import { InlineResponse } from '../models/inline-response.model';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ConditionnementsClientService {
  private apiURL = environment.apiURL;

  private serviceUrl = this.apiURL + '/services/conditionnement';

  constructor(private http: HttpClient) {}

  public getConditionnementData(): Observable<IConditionnement> {
    return this.http.get<IConditionnement>(this.serviceUrl);
  }

  public addConditionnementData(codeHecate: number, designation: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('codeHecate', codeHecate.toString())
      .set('designation', designation)
      .set('oper', 'add')
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString());

    return this.http.post<InlineResponse>(this.serviceUrl, params, options);
  }

  public updateConditionnementData(conditionnement: Conditionnement): Observable<InlineResponse> {
    let params = new HttpParams().set('codeHecate', conditionnement.codeHecate).set('designation', conditionnement.designation).set('oper', 'edit').set('id', conditionnement.id);

    return this.http.post<InlineResponse>(this.serviceUrl, params, options);
  }
}
